import React from "react";
import FluxoCanvasPizzaria from "./FluxoCanvasPizzaria";
import FluxoCanvasSalao from "./FluxoCanvasSalao";
import FluxoCanvasAssistencia from "./FluxoCanvasAssistencia";
import FluxoCanvasLavaJato from "./FluxoCanvasLavaJato";

/**
 * FluxoCanvas — dispatcher dos layouts dedicados por nicho (desktop, xl+).
 *
 * Cada nicho tem seu proprio componente hardcoded com storytelling visual.
 * O caminho generico foi removido: hoje todo nicho precisa de layout dedicado.
 * Mobile/tablet (<1280px) e servido pelo FluxoVertical.
 */
export default function FluxoCanvas({ fluxo }) {
  if (fluxo.id === "pizzaria") return <FluxoCanvasPizzaria />;
  if (fluxo.id === "salao") return <FluxoCanvasSalao />;
  if (fluxo.id === "assistencia") return <FluxoCanvasAssistencia />;
  if (fluxo.id === "lava_jato") return <FluxoCanvasLavaJato />;
  return null;
}
